// extracted by mini-css-extract-plugin
export var acitonButtons = "_hj-0";
export var additionalIcon = "_hj-f";
export var block = "_hj-1";
export var blockContent = "_hj-7";
export var blockDescription = "_hj-8";
export var blockIcon = "_hj-9";
export var blockTitle = "_hj-6";
export var border = "_hj-a";
export var center = "_hj-l";
export var edge = "_hj-b";
export var edgeLabel = "_hj-c";
export var edgePath = "_hj-d";
export var error = "_hj-e";
export var flowchart = "_hj-g";
export var flowchartContent = "_hj-h";
export var highlighted = "_hj-3";
export var hover = "_hj-4";
export var icon = "_hj-i";
export var left = "_hj-m";
export var navButton = "_hj-j";
export var navButtons = "_hj-k";
export var right = "_hj-n";
export var selected = "_hj-2";
export var small = "_hj-5";